import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceChangeContactCreditsDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-change-contact-credits-dialog-tour',
    name: 'Update Credits Tour',
    steps: [
        {
            targetId: 'invoice-change-credits-summary',
            title: 'Invoice Math',
            description: 'Lots sold, less charges and discounts, less credits applied, equals the invoice amount. It updates live as you apply credits.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-change-credits-grid',
            title: 'Available Credits',
            description: 'Select the contact credits to apply to this invoice. Use the add button in the section header to create a new credit for this contact. Click Update Credits to save.',
            position: 'top',
        },
    ]
}
